// JavaScript source code
import { useRef, useState, useEffect } from 'react';
import GameImageHeader from './GameImageHeader';
import './styles/PlayerInfo.css';
import webContentStrings from "./ContentStrings/LocalizedStrings.js";
import { createPortal } from 'react-dom';
import { IsMobile } from './Utilities.js';

function PlayerInfo() {
    const [mobile, setMobile] = useState(IsMobile());

    useEffect(() => {
        const handleResize = () => {
            setMobile(IsMobile());
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="playerPage">
            <div className={"whyLudareContainer" + (mobile ? "Mobile" : "")}>
                <img className="whyLudareIcon" src="/Icon_Renders/NoDepthBlur/Ludare_IconRender_NDP_LudareLogo_01.png" />
                <div className="whyLudareTextContainer">
                    <p className="whyLudareTitle">{webContentStrings.playerInfoStrings.whyLudareTitle1} <span style={{ color: "#f9b422" }}>{webContentStrings.playerInfoStrings.whyLudareTitle2}</span></p>
                    <p className="whyLudareInfo">{webContentStrings.playerInfoStrings.whyLudareDesc}</p>
                </div>
            </div>

            <div className={"supportContainer" + (mobile ? "Mobile" : "")}>
                <div className="supportTextContainer">
                    <p className="supportTitle">{webContentStrings.playerInfoStrings.supportTitle1} <span style={{ color: "#FFFFFF" }}>{webContentStrings.playerInfoStrings.supportTitle2}</span></p>
                    <p className="supportInfo">{webContentStrings.playerInfoStrings.supportDesc}</p>
                </div>
                <img className="supportIcon" src="/WebsiteGameCardsTiltShift.png" />
            </div>

            <div className={"influenceContainer" + (mobile ? "Mobile" : "")}>
                <img className="influenceIcon" src="/Icon_Renders/NoDepthBlur/Ludare_IconRender_NDP_Graph_01.png.png" />
                <div className="influenceTextContainer">
                    <p className="influenceTitle"><span style={{ color: "#f9b422" }}>{webContentStrings.playerInfoStrings.influenceTitle1}</span> {webContentStrings.playerInfoStrings.influenceTitle2}</p>
                    <p className="influenceInfo">{webContentStrings.playerInfoStrings.influenceDesc}</p>
                </div>
            </div>

            <div className={"favoriteContainer" + (mobile ? "Mobile" : "")}>
                <div className="favoriteTextContainer">
                    <p className="favoriteTitle">{webContentStrings.playerInfoStrings.favoriteTitle1} <span style={{ color: "#FFFFFF" }}>{webContentStrings.playerInfoStrings.favoriteTitle2}</span></p>
                    <p className="favoriteInfo">{webContentStrings.playerInfoStrings.favoriteDesc}</p>
                </div>
                <img className="favoriteIcon" src="/Icon_Renders/NoDepthBlur/Ludare_IconRender_NDP_Heart_01.png" />
            </div>

        </div>
    );
}

/*<div className="titleLine">
                <GameImageHeader />
                <div className="topBody">
                    <div className="infoPlayer">
                        <h2 className="taglineTopPlayer">Support A New Favorite Game</h2>
                        <h2 className="taglineBottomPlayer">Just By Playing It</h2>
                        <p className="subTagLinePlayer">Try a bunch of new games for one price.<br/>Support your favorites just by playing.</p>
                    </div>
                </div>
            </div>*/

export default PlayerInfo;